import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import {
  Row, Col,
  List, Card, Tag, Spin,
  Button, Popconfirm,
  SuccessNotification,
} from "components/common";
import { asPrice } from "utils/text";
import {
  callGetApiWithAuth,
  callDeleteApiWithAuth,
  callPostApiWithAuth,
} from "utils/api";
import { varIs, varLabel } from "common/var";
import EditModal from "../edit/EditModal";
import { Wrapper } from "./FailedSection.styled";

export default function FailedSection(props) {
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [akadtUpProduct, setAkadtUpProduct] = useState(undefined);
  const [akadtAbleProducts, setAkadtAbleProducts] = useState([]);

  const onGetListData = (res) => {
    setIsLoading(false);
    setListData(res.data);
    if(res.data.length > 0) props.setExistFailed(true);
    props.setShouldLoad(false);
  };
  const onFailListData = () => {
    setIsLoading(false);
    props.setShouldLoad(false);
  };
  const loadListData = () => {
    setIsLoading(true);
    callGetApiWithAuth(
      `my_account/subscription/faileds`,
      onGetListData,
      onFailListData
    );
  };

  useEffect(() => {
    if (props.shouldLoad) {
      loadListData();
      callGetApiWithAuth(
        `my_account/subscription/check_akadt_upgrade`,
        ({ data }) => {
          setAkadtAbleProducts(data.able_products);
          setAkadtUpProduct(data.up_product);
        },
      )
    }
  }, [props.shouldLoad]);

  return (
    <Wrapper>
      {listData?.length > 0 ? (
        <>
          <div className="payment-header">
            <span>Failed Payments</span>
          </div>
          <List
            grid={{ gutter: 24, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 4 }}
            dataSource={listData}
            className="subsc-list"
            renderItem={(item) => (
              <List.Item>
                <SubscriptionCard
                  data={item}
                  loadListData={loadListData}
                  setShouldLoad={props.setShouldLoad}
                  akadtAbleProducts={akadtAbleProducts}
                  akadtUpProduct={akadtUpProduct}
                />
              </List.Item>
            )}
            loading={{
              spinning: isLoading || false,
              indicator: <Spin spinning={true} className={`spinner`} />,
            }}
          />
        </>
      ) : (
        ""
      )}
    </Wrapper>
  );
}

const SubscriptionCard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isEdition, setIsEdition] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isAkadtAble, setIsAkadtAble] = useState(false);

  const onCancelDone = (res) => {
    setIsCancelling(false);
    SuccessNotification(res.message);
    props.setShouldLoad(true);
  };
  const onCancelFail = () => {
    setIsCancelling(false);
  };
  const handleCancel = () => {
    setIsCancelling(true);
    callDeleteApiWithAuth(
      `my_account/subscription/${props.data.id}/cancel`,
      onCancelDone,
      onCancelFail
    );
  };

  const handleResume = () => {
    dispatch({
      type: "checkout.ADD_RESUME_CART",
      payload: {
        orderDetail: props.data,
        subscriptionIds: [props.data.id],
      },
    });
    history.push("/checkout");
  };

  const handleUpAkadt = () => {
    dispatch({
      type: 'checkout.SET_ORDER_DETAILS',
      payload: [
        {
          product: props.akadtUpProduct,
          quantity: 1,
          pay_cycle: '',
          contained_products: [],
        }
      ]
    })
    history.push("/checkout");
  }

  useEffect(() => {
    if (props.data && props.akadtUpProduct) {
      let isSku = false;
      props.akadtAbleProducts.forEach(product => {
        if (product.sku === props.data.product.sku) {
          isSku = true;
        }
      });
      if (props.akadtUpProduct && isSku) {
        setIsAkadtAble(true)
      } else {
        setIsAkadtAble(false)
      }
    }
  }, [props.data, props.akadtAbleProducts, props.akadtUpProduct])

  return (
    <div className="past-card">
      <div>
        <div className="pro-c">
          <div className="pro-c-1">
            <div className="payment-product-image">
              <img src={props.data.product.image_path} />
            </div>
          </div>
          <div className="pro-c-2">
            <div className="price-container">
              <div className="payment-title">{props.data.product.title}</div>
              <div className="payment-tag">
                <Tag color="red" className="failed">
                  Failed
                </Tag>
              </div>
            </div>
          </div>
        </div>
        <Row gutter={[10, 10]}>
          <Col span={8}>
            <div className="bv-container">
              <div className="bv-title">Vol. (BV)</div>
              <div className="bv-value">
                {props.data.product.recurring_pv * props.data.quantity}
              </div>
            </div>
          </Col>
          <Col span={8}>
            <div className="bv-container">
              <div className="bv-title">Quantity</div>
              <div className="bv-value">{props.data.quantity}</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="bv-container">
              <div className="bv-title">Price</div>
              <div className="bv-value">
                {asPrice(props.data.product.recurring_price)}
              </div>
            </div>
          </Col>

          <Col span={8}>
            <div className="bv-container">
              <div className="bv-title">Next Bill Date:</div>
              <div className="bv-value-1">
                {moment(props.data.next_date).format("MMM D, YYYY")}
              </div>
            </div>
          </Col>
          <Col span={8}>
            <div className="bv-container">
              <div className="bv-title">Frequency:</div>
              <div className="bv-value-1">
                {varLabel("subscription.payCycle", props.data.pay_cycle)}
              </div>
            </div>
          </Col>
          <Col span={8}>
            <div className="bv-container">
              <div className="bv-title">Date Created</div>
              <div className="bv-value-2">
                {moment(props.data.created_at).format("MMM D, YYYY")}
              </div>
            </div>
          </Col>
        </Row>
        {props.data.contained_products.length > 0 ? (
          <div className="billing-container">
            Details:
            <span>
              {props.data.contained_products.map((el, index) => (
                <span>
                  {el.product.title}
                  {` x `}
                  {el.quantity}
                  {index < props.data.contained_products.length - 1 ? ", " : ""}
                </span>
              ))}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="action-buttons-container">
        <Button
          className="edit"
          onClick={() => setIsEdition(true)}
          size="small"
        >
          Edit
        </Button>
        {varIs("subscription.isWaiting", props.data.is_waiting, "no") && (
          <Popconfirm onConfirm={handleResume}>
            <Button className="resume-button" size="small">
              Resume
            </Button>
          </Popconfirm>
        )}
        <Popconfirm onConfirm={handleCancel}>
          <Button
            className="cancel"
            size="small"
            bgColor="white"
            border
            color="black"
            loading={isCancelling}
          >
            Cancel
          </Button>
        </Popconfirm>
      </div>
      {isAkadtAble && 
      <>
        <div className="action-buttons-container">
          <Popconfirm onConfirm={handleUpAkadt}>
            <Button >
              Upgrade to Akashx + DreamTrips
            </Button>
          </Popconfirm>
        </div>
      </>}
      {isEdition && (
        <EditModal
          data={props.data}
          setIsEdition={setIsEdition}
          setShouldLoad={props.setShouldLoad}
        />
      )}
    </div>
  );
};
